import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { emptyArray } from 'ui-components/default-props/empty';
import { ResourceDisplayInfo } from './resource-display-info';
import { TermsAndConditions } from './terms-and-conditions';
import { useWalletRegistrationModalContext } from '../wallet-registration/contexts/wallet-registration-modal-context';
import styles from './carrier-update-modal.module.less';

export const WalletUpdateModalBody = ({
  setCanProgress,
  labelProviderIdsToRegister = emptyArray,
  newResourceUpdates = emptyArray,
  newInsuranceProviderIds = emptyArray,
}) => {
  const { terms, nonDefaultTerms } = useWalletRegistrationModalContext();
  const noTerms = terms.length === 0 && Object.keys(nonDefaultTerms).length === 0;

  return (
    <div className={styles['body-container']}>
      {!noTerms && (
        <div className={styles['left-side-modal']}>
          <TermsAndConditions newInsuranceProviderIds={newInsuranceProviderIds} setCanProgress={setCanProgress} />
        </div>
      )}
      <div className={classnames({ [styles['right-side-modal']]: !noTerms })}>
        <ResourceDisplayInfo
          labelProviderIdsToRegister={labelProviderIdsToRegister}
          newInsuranceProviderIds={newInsuranceProviderIds}
          newResourceUpdates={newResourceUpdates}
        />
      </div>
    </div>
  );
};

WalletUpdateModalBody.propTypes = {
  setCanProgress: PropTypes.func.isRequired,
  labelProviderIdsToRegister: PropTypes.array,
  newResourceUpdates: PropTypes.array,
  newInsuranceProviderIds: PropTypes.array,
};
